/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Double_Magnum_3lInputs */

const en_val_double_magnum_3l = /** @type {(inputs: Val_Double_Magnum_3lInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double Magnum (3L)`)
};

const es_val_double_magnum_3l = /** @type {(inputs: Val_Double_Magnum_3lInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doble Magnum (3L)`)
};

const fr_val_double_magnum_3l = /** @type {(inputs: Val_Double_Magnum_3lInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double Magnum (3L)`)
};

const de_val_double_magnum_3l = /** @type {(inputs: Val_Double_Magnum_3lInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doppel-Magnum (3L)`)
};

const ja_val_double_magnum_3l = /** @type {(inputs: Val_Double_Magnum_3lInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダブルマグナム (3L)`)
};

const zh_val_double_magnum_3l = /** @type {(inputs: Val_Double_Magnum_3lInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`双瓶大装 (3L)`)
};

const ar_val_double_magnum_3l = /** @type {(inputs: Val_Double_Magnum_3lInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ماغنوم مزدوج (3 لتر)`)
};

const id_val_double_magnum_3l = /** @type {(inputs: Val_Double_Magnum_3lInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magnum Ganda (3L)`)
};

const it_val_double_magnum_3l = /** @type {(inputs: Val_Double_Magnum_3lInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jéroboam (Doppio Magnum) (3L)`)
};

const ru_val_double_magnum_3l = /** @type {(inputs: Val_Double_Magnum_3lInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Двойной Магнум (3л)`)
};

const pt_val_double_magnum_3l = /** @type {(inputs: Val_Double_Magnum_3lInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplo Magnum (3L)`)
};

const ko_val_double_magnum_3l = /** @type {(inputs: Val_Double_Magnum_3lInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`더블 매그넘 (3L)`)
};

/**
* | output |
* | --- |
* | "Double Magnum (3L)" |
*
* @param {Val_Double_Magnum_3lInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_double_magnum_3l = /** @type {((inputs?: Val_Double_Magnum_3lInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Double_Magnum_3lInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_double_magnum_3l(inputs)
	if (locale === "es") return es_val_double_magnum_3l(inputs)
	if (locale === "fr") return fr_val_double_magnum_3l(inputs)
	if (locale === "de") return de_val_double_magnum_3l(inputs)
	if (locale === "ja") return ja_val_double_magnum_3l(inputs)
	if (locale === "zh") return zh_val_double_magnum_3l(inputs)
	if (locale === "ar") return ar_val_double_magnum_3l(inputs)
	if (locale === "id") return id_val_double_magnum_3l(inputs)
	if (locale === "it") return it_val_double_magnum_3l(inputs)
	if (locale === "ru") return ru_val_double_magnum_3l(inputs)
	if (locale === "pt") return pt_val_double_magnum_3l(inputs)
	return ko_val_double_magnum_3l(inputs)
});